<template lang="pug">
v-fade-transition
  v-btn.scroll-top-btn.defult-btn-color(
    v-if="visible",
    fab,
    small,
    color="primary",
    @click="scrollToTop"
  )
    i.fas.fa-angle-double-up
</template>

<style scoped>
.scroll-top-btn {
  position: fixed;
  bottom: 16px;
  left: 16px;
  z-index: 999;
}
</style>

<script>
export default {
  props: {
    visible: Boolean,
  },
  methods: {
    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
  },
}
</script>
